import React, { useState } from 'react';
import { toast } from 'react-toastify';
import axios from 'axios';
import '../../styles/ForgotPassword.css';
import { FaUnlockAlt } from 'react-icons/fa';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      toast.error('Please enter your email address');
      return;
    }
    
    try {
      setIsLoading(true);
      
const response = await axios.post(
  `${process.env.REACT_APP_API_URL}/password/forgot`,{
        email_id: email
      });
    
      
      if (response.data.success) {
        setIsSuccess(true);
        toast.success('Password reset link sent to your email!');
      }
      
    } catch (error) {
      console.error('Error requesting password reset:', error);
      toast.error(error.response?.data?.message || 'Something went wrong. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };
  
  return (
    <div className="forgot-password-container">
      <div className="forgot-password-card">
        <div className="forgot-password-logo">
          <div className="logo-circle">
            <FaUnlockAlt className="logo-icon" />
          </div>
          <h2>Forgot Password</h2>
        </div>
        
        {isSuccess ? (
          <div className="success-message">
            <h3>Check Your Email</h3>
            <p>We've sent a password reset link to:</p>
            <p className="email-highlight">{email}</p>
            <p>Please check your inbox and follow the instructions to reset your password.</p>
            <button 
              className="back-button"
              onClick={() => window.location.href = '/'}
            >
              Back to Login
            </button>
          </div>
        ) : (
          <>
            <div className="instruction-text">
              <p>Enter your email address and we'll send you a link to reset your password.</p>
            </div>
            
            <form onSubmit={handleSubmit} className="forgot-password-form">
              <div className="form-group">
                <label htmlFor="email">
                  Email Address
                </label>
                <input
                  type="email"
                  id="email"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              
              <button 
                type="submit" 
                className="submit1-button"
                disabled={isLoading}
              >
                {isLoading ? 'Sending...' : 'Send Reset Link'}
              </button>
            </form>
            
            <div className="back-to-login">
              <p>
                Remember your password? <a href="/">Login here</a>
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;